import React, { useState } from "react";

export default ({ image, title, imgClass, showOnMobile}) =>  {
  const [open, setOpen] = useState(false);
  const windowWidth = window.innerWidth;
  const mobileWidth = 425;

  const onWrapperClick = (e) => {
    if (e.target.id !== 'weight-and-balance-schema') {
      setOpen(false);
    }
  }

  const onOpen = () => {
    if ((windowWidth <= mobileWidth && showOnMobile) || windowWidth > mobileWidth) {
      setOpen(true)
    }
  }

  return (
    <div>
      <div onClick={onOpen} className='zoom-img-source'>
        <img src={image} alt={title} className={imgClass}/>
      </div>
      { open && (
        <span className='zoom-img-wrapper'>
          <span className='zoom-blur-bg' onClick={(e) => onWrapperClick(e)}/>
          <span className='zoom-img'>
            <span className='icon cancel-circled zoom-close' onClick={() => setOpen(false)}/>
            <img src={image} alt={title} id='weight-and-balance-schema'/>
          </span>
        </span>
      )}
    </div>
  )
}
